import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import storage from '@/plugins/storage'

// views
import Login from '@/views/login/Login.vue'
import ActiveLogin from '@/views/login/ActiveLogin.vue'
import LoginCallback from '@/views/login/LoginCallback'
import LoginActiveCallback from '@/views/login/LoginActiveCallback'
import LoginConcat from '@/views/login/LoginConcat'
import LoginLoading from '@/views/login/LoginLoading'

// views service-center login
import serviceCenterLogin from '@/views/service-center-login/Login.vue'
import LoginCenterCallback from '@/views/service-center-login/LoginCallback'
import LoginCenterActiveCallback from '@/views/service-center-login/LoginActiveCallback'
import LoginCenterConcat from '@/views/service-center-login/LoginConcat'
import LoginCenterLoading from '@/views/service-center-login/LoginLoading'

// import LoginSms from '@/views/login/LoginSms'
import Index from '@/views/Index'
import Home from '@/views/Home'
import searchResult from '@/views/class-search-result/search-result.vue'
import globalSearch from '@/views/global-search/index.vue'
import serviceCenter from '@/views/service-center/service-center'
// import CourseMain from '@/views/course/Index'
import Live from '@/views/live/Index'
import LiveDetail from '@/views/live/Detail'
import Record from '@/views/record/IndexV2'
import RecordDetail from '@/views/record/Detail'
import VideoDetail from '@/views/record/VideoDetail'
// 个人信息修改页面
import ProfileSettings from '@/views/profile/ProfileSettings'
import officeName from '@/views/profile/person/officeName'
import phone from '@/views/profile/person/phone'
import userName from '@/views/profile/person/userName'
import Location from '@/views/profile/person/Location.vue'

// 市场扩展
import Expand from '@/views/expand/index'
import ExpandPreview from '@/views/expand/preview'

// 课程介绍页面
import DataReadOnly from '@/views/components/DataReadOnly'
import ShareLive from '@/views/share/ShareLive'
// import Push from '@/views/Push'
import Debug from '@/views/Debug'
// 引入神策数据监听
import sensorHelp from '@/vendor/sensors/help'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/service-center-login',
      name: 'serviceCenterLogin',
      component: serviceCenterLogin,
    },
    {
      path: '/service-center-login-callback',
      name: 'LoginCenterCallback',
      component: LoginCenterCallback,
    },
    {
      path: '/service-center-active-callback',
      name: 'LoginCenterActiveCallback',
      component: LoginCenterActiveCallback,
    },
    {
      path: '/service-center-concat',
      name: 'LoginCenterConcat',
      component: LoginCenterConcat,
    },
    {
      path: '/service-center-loading',
      name: 'LoginCenterLoading',
      component: LoginCenterLoading,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/active-login',
      name: 'ActiveLogin',
      component: ActiveLogin,
    },
    {
      path: '/login-callback',
      name: 'LoginCallback',
      component: LoginCallback,
    }, {
      path: '/login-active-callback',
      name: 'LoginActiveCallback',
      component: LoginActiveCallback,
    },
    // {
    //   path: '/login-sms',
    //   name: 'LoginSms',
    //   component: LoginSms,
    // },
    {
      path: '/login-concat',
      name: 'LoginConcat',
      component: LoginConcat,
    },
    {
      path: '/login-by-ticket',
      name: 'LoginByTicket',
      component: LoginLoading,
    },
    {
      path: '/login-by-token',
      name: 'LoginByToken',
      component: LoginLoading,
    },
    // { path: '/course',
    //   name: 'CourseMain',
    //   component: CourseMain,
    //   redirect: '/course/lives',
    //   children: [
    //     { path: 'lives', name: 'Live', component: Live },
    //     { path: 'records', name: 'Record', component: Record },
    //   ],
    // },
    { path: '/lives', name: 'Live', component: Live },
    { path: '/class-search-result', name: 'class-search-result', component: searchResult },
    { path: '/global-search', name: 'global-search', component: globalSearch },
    { path: '/service-center',
      name: 'service-center',
      component: serviceCenter,
      children: [
        {
          path: '/service-center/all',
          name: 'all',
          component: () => import(/* webpackChunkName: "prodbook" */ './views/service-center/all/all.vue'),
        },
        {
          path: '/service-center/prodbook',
          name: 'prodbook',
          component: () => import(/* webpackChunkName: "prodbook" */ './views/service-center/prod-book/ProdBook.vue'),
        },
        {
          path: '/service-center/entcourse',
          name: 'entcourse',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/ent-course/EntCourse.vue'),
        },
        {
          path: '/service-center/corporate-template-course',
          name: 'corporate-template-course',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/corporate-template-course/CorporateTemplateCourse.vue'),
        },
        {
          path: '/service-center/report-course',
          name: 'report-course',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/report-course/ReportCourse.vue'),
        },
        {
          path: '/service-center/skill-course',
          name: 'skill-course',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/skill-course/SkillCourse.vue'),
        },
        {
          path: '/service-center/detail',
          name: 'detail',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/detail/detail.vue'),
        },
        {
          path: '/service-center/online-course',
          name: 'online-course',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/online-course/online-course.vue'),
        },
        {
          path: '/service-center/law-exam',
          name: 'law-exam',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/law-exam/LawExam.vue'),
        },
        {
          path: '/service-center/law-exam-report',
          name: 'law-exam-report',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/law-exam-report/LawExamReport.vue'),
        },
        {
          path: '/service-center/labor-exam',
          name: 'law-exam',
          component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/labor-exam/LaborExam.vue'),
        },
      ] },
    {
      path: '/law-exam-report',
      name: 'law-exam-report',
      component: () => import(/* webpackChunkName: "entcourse" */ './views/service-center/law-exam-report/LawExamReport.vue'),
    },
    { path: '/records', name: 'Record', component: Record },
    { path: '/detail/:courseId', name: 'LiveDetail', component: LiveDetail },
    { path: '/readonly/:courseId', name: 'LiveReadOnly', component: DataReadOnly },
    { path: '/record/readonly/:courseId', name: 'RecordReadOnly', component: DataReadOnly },
    {
      path: '/record/detail/:courseId',
      name: 'RecordDetail',
      component: RecordDetail,
      children: [{
        name: 'VideoDetail',
        path: ':videoId',
        component: VideoDetail,
      }],
    },
    {
      path: '/expand',
      name: 'Expand',
      component: Expand,
    },
    {
      path: '/expand/preview/:id',
      name: 'ExpandPreview',
      component: ExpandPreview,
    },
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    { path: '/profile-settings', name: 'ProfileSettings', component: ProfileSettings },
    { path: '/userName', name: 'userName', component: userName },
    { path: '/phone', name: 'phone', component: phone },
    { path: '/officeName', name: 'officeName', component: officeName },
    { path: '/location', name: 'location', component: Location },

    // { path: '/push', name: 'Push', component: Push },
    { path: '/debug/do-not-publish/:courseId', name: 'Debug', component: Debug },
    // 无页面跳转
    { path: '/share/live/:cid', name: 'ShareLive', component: ShareLive },
    { path: '/404', name: 'NotFound', component: () => import('@/views/404') },
    { path: '*', redirect: '/404' },
  ],
})

// #region 身份验证
// 需要身份验证的 RouterNames
const noCacheUrlRoutesNames = ['Login', 'LoginCallback', 'LoginByTicket', 'LoginByToken', 'LoginConcat']

function getCookie (name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';') // 把cookie分割成组
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i] // 取得字符串
    while (c.charAt(0) == ' ') { // 判断一下字符串有没有前导空格
      c = c.substring(1, c.length) // 有的话，从第二位开始取
    }
    if (c.indexOf(nameEQ) == 0) { // 如果含有我们要的name
      return unescape(c.substring(nameEQ.length, c.length)) // 解码并截取我们要值
    }
  }
  return false
}

router.beforeEach(async (to, from, next) => {
  let redirectArr = ['devschool.icourt.cc', 'testschool.icourt.cc', 'preschool.icourt.cc', 'school.icourt.cc']
  const { host, origin, hash } = window.location
  let hostItem = redirectArr.filter(item => item === host)
  if (hostItem.length > 0) {
    let newHost = origin.replace('school.icourt.cc', 'school.alphalawyer.cn')
    let redirectUrl = `${newHost}/${hash}`
    location.href = redirectUrl
  }
  // 票据登录
  if (to.path.indexOf('/login-by-ticket') > -1) {
    await store.dispatch('app/loginByTicket', to.query)
  }
  // 如果是服务中心加上cookie的path
  if (to.path.indexOf('/service-center') > -1) {
    document.cookie = 'path=service-center'
    console.log(document.cookie, 'document.cookiedocument.cookie')
  }
  // 如果跳转过来带有md5，那么是第三方登录
  if (to.path.indexOf('/login-by-token') > -1) {
    if (to.query.systemmark) {
      sessionStorage.setItem('redirectType', to.query.systemmark)
      sessionStorage.setItem('tempUserId', to.query.userId)

      if (to.query.systemmark === '3C') {
        document.getElementsByTagName('title')[0].innerText = getCookie('officeSchemeName') || ''
        document.querySelector('link[rel="shortcut icon"]').href = getCookie('officeSchemeLogo') || ''
      }
    }
    await store.dispatch('app/checkUser', to.query)
  }
  // 判断用户是否处于登陆状态，如果存在token，那么刷新登陆状态，否则vuex自动清空登陆状态
  if (storage.get('token')) {
    store.commit('app/setLogin', true)
    store.commit('app/refreshUserInfo')
  }
  if (storage.get('isBindAlpha')) {
    let isBind = JSON.parse(storage.get('isBindAlpha'))
    store.commit('app/setIsBindAlpha', isBind || false)
  }
  // 存储地址
  if (!noCacheUrlRoutesNames.includes(to.name)) {
    storage.set('cacheUrl', to.fullPath)
  }
  next()
})

router.afterEach((to, from) => {
  sensorHelp.autoTrackSinglePage()
})

export default router
